import { genId } from '@/utils';
import { produce } from 'immer';
import { create } from 'zustand';

export enum ContainerTypeEnum {
  Containers = 'containers',
  InitContainers = 'initContainers',
}

export interface DockerItem {
  /** 镜像来源 */
  imageOrigin: string;
  /** 镜像 - select 组件空值为 undefined */
  image?: string;
  /** 容器名称 */
  containerName: string;
  /** 容器类型 */
  containerType: ContainerTypeEnum;
  /** cpu 预留 */
  cpuReserve?: number;
  /** cpu 限制 */
  cpuLimit?: number;
  /** 内存预留 */
  memoryReserve?: number;
  /** 内存限制 */
  memoryLimit?: number;
  /** gpu 类型 */
  gpuType?: string;
  /** gpu 限制 */
  gpuLimit?: number;
}

/** 这里是添加一个容器的时候状态管理, 导出是因为可以添加多个容器 */
export interface DockerSettingState {
  dockerSetting?: DockerItem;
  /** 校验函数 */
  validateDockerSetting?: () => Promise<boolean>;
}

// 默认状态
const getInitDockerSetting = () => {
  return {
    dockerSetting: {
      imageOrigin: 'docker_hub',
      image: undefined,
      containerName: genId({ prefix: 'container-' }),
      containerType: ContainerTypeEnum.Containers, // 默认容器类型 containers | initContainers
      cpuReserve: undefined,
      cpuLimit: undefined,
      memoryReserve: undefined,
      memoryLimit: undefined,
      gpuType: undefined,
      gpuLimit: undefined,
    },
  };
};

interface DockerSettingAction {
  /** 局部更新 或者 表单更新 */
  updateDockerSetting: (dockerSetting: Partial<DockerItem>) => void;
  setvalidateDockerSetting: (validate: () => Promise<boolean>) => void;
  reset: () => void;
}

export const useDockerSettingStore = create<DockerSettingState & DockerSettingAction>()((set) => ({
  ...getInitDockerSetting(),
  updateDockerSetting: (dockerSetting) =>
    set(
      produce((state: DockerSettingState) => {
        state.dockerSetting = { ...state.dockerSetting, ...dockerSetting };
      }),
    ),
  setvalidateDockerSetting: (validate) => set({ validateDockerSetting: validate }),
  reset: () => {
    set(getInitDockerSetting());
  },
}));
